//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { handleListBookTranslation, handleListGrammarContent, handleListVocabContent } from './thunks';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const book_pages_translations_selector = (state) => state.book_pages_translations;


export const usePageTranslations = () => {
    const book_pages_translations =  useSelector(book_pages_translations_selector, shallowEqual);
    const dispatch = useDispatch();
    async function handleFetchPageTranslations(book_id){
        try {
            await dispatch(handleListBookTranslation(book_id))
        } catch (error) {
            logToSentry({
                message: 'Error in handleFetchPageTranslations',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'FETCH_PAGE_TRANSLATIONS'
            });
            console.log("error in listing book content..")
        }
    }
    return {
        book_pages_translations,
        handleFetchPageTranslations
    };
}
const book_grammar_content_selector = (state) => state.book_grammar_content;

export const usePageGrammarContent = () => {
    const book_grammar_content =  useSelector(book_grammar_content_selector, shallowEqual);
    const dispatch = useDispatch();
    async function handleFetchBookGrammarContent(book_id){
        try {
            await dispatch(handleListGrammarContent(book_id))
        } catch (error) {
            logToSentry({
                message: 'Error in handleFetchBookGrammarContent',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'FETCH_BOOK_GRAMMAR_CONTENT'
            });
            console.log("error in listing book content..")
        }
    }
    return {
        book_grammar_content,
        handleFetchBookGrammarContent
    };
}
const book_vocab_content_selector = (state) => state.book_vocab_content;

export const usePageVocabContent = () => {
    const book_vocb_content =  useSelector(book_vocab_content_selector, shallowEqual);
    const dispatch = useDispatch();
    async function handleFetchBookVocabContent(book_id){
        try {
            await dispatch(handleListVocabContent(book_id))
        } catch (error) {
            logToSentry({
                message: 'Error in handleFetchBookVocabContent',
                error,
                module: 'PAGE_TRANSLATIONS',
                operation: 'FETCH_BOOK_VOCAB_CONTENT'
            });
            console.log("error in listing book content..")
        }
    }
    return {
        book_vocb_content,
        handleFetchBookVocabContent
    };
}